function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "assets/Icons/info");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "assets/Icons/info",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,6 C11.373,6 6,11.373 6,18 C6,24.627 11.373,30 18,30 C24.627,30 30,24.627 30,18 C30,11.373 24.627,6 18,6 Z M20.619,17.0415 C20.1,18.9705 17.6925,23.892 17.949,24.456 C18.252,25.119 19.3635,23.406 19.782,23.8575 C20.3325,24.4515 17.919,26.1855 16.596,26.34 C15.474,26.4705 13.6935,26.3025 13.8915,24.6585 C14.0625,23.238 16.284,17.9745 16.5885,17.334 C17.0385,16.3905 16.914,15.852 16.212,16.458 C16.1145,16.542 15.3525,17.2425 15.0165,16.9755 C14.931,16.9065 14.787,16.7115 14.964,16.4175 C15.8205,14.9955 19.2105,13.3035 20.5725,14.886 C21.0915,15.4905 20.8035,16.356 20.619,17.0415 Z M20.2815,13.1955 C19.299,13.1955 18.5025,12.399 18.5025,11.4165 C18.5025,10.434 19.299,9.6375 20.2815,9.6375 C21.264,9.6375 22.0605,10.434 22.0605,11.4165 C22.059,12.399 21.2625,13.1955 20.2815,13.1955 Z",
  id: "Shape",
  fill: "#097FAC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.964,16.4175 C14.787,16.7115 14.931,16.9065 15.0165,16.9755 C15.3525,17.244 16.1145,16.542 16.212,16.458 C16.914,15.8535 17.0385,16.3905 16.5885,17.334 C16.284,17.973 14.061,23.238 13.8915,24.6585 C13.6935,26.3025 15.4755,26.4705 16.596,26.34 C17.919,26.1855 20.3325,24.4515 19.782,23.8575 C19.3635,23.406 18.252,25.1205 17.949,24.456 C17.6925,23.892 20.1,18.9705 20.619,17.0415 C20.8035,16.356 21.0915,15.4905 20.571,14.886 C19.2105,13.3035 15.819,14.9955 14.964,16.4175 Z",
  id: "Path"
}));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.cfad9890.svg";
export { ForwardRef as ReactComponent };